import React from 'react';
import { get } from 'lodash';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import { connect } from 'react-redux';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';
import { INVENTORY_TYPES } from 'client/constants/inventory-types';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';

const MAKES = [
  'Chrysler',
  'Dodge',
  'Jeep',
  'Ram',
  'FIAT',
  'Alfa Romeo',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'GMC',
  'BMW',
];

const getShop3944RecipeName = (shop3944Recipe, type, make) => {
  if (!MAKES.includes(make)) return 'ctrl';

  if (['chal1', 'chal2'].includes(shop3944Recipe) && type && !isUsed(type)) {
    return `${shop3944Recipe}-new`;
  }

  if (['chal1', 'chal2'].includes(shop3944Recipe) && type === INVENTORY_TYPES.CPO && make === 'BMW') {
    return `${shop3944Recipe}-used`;
  }

  if (shop3944Recipe === 'chal3') {
    return 'chal3';
  }

  return 'ctrl';
};

const PREPARE_SHOP_3944_PROPS = {
  embeded: ({ shop3944RecipeName, ...restProps }) => {
    const make = get(restProps, 'params.make');
    const type = get(restProps, 'params.type');

    const shop3944Recipe = getShop3944RecipeName(shop3944RecipeName, type, make);
    return { make, ...restProps, options: { ...restProps.options, shop3944Recipe } };
  },

  basicDrawer: ({ shop3944RecipeName, ...restProps }) => {
    const make = get(restProps, 'componentData.params.make');
    const type = get(restProps, 'componentData.params.type');

    const shop3944Recipe = getShop3944RecipeName(shop3944RecipeName, type, make);

    return {
      make,
      ...restProps,
      componentData: {
        ...restProps.componentData,
        options: { ...restProps.componentData.options, shop3944Recipe },
      },
    };
  },

  transparentPricing: ({ shop3944RecipeName, ...restProps }) => {
    const make = get(restProps, 'params.vehicle.make.name');
    let type = get(restProps, 'params.vehicle.publicationState', get(restProps, 'params.vehicle.pubStates'));
    type = typeof type === 'object' ? Object.keys(type)[0] : type;

    const shop3944Recipe = getShop3944RecipeName(shop3944RecipeName, type, make);

    return { make, ...restProps, options: { ...restProps.options, shop3944Recipe } };
  },
};

export const withShop3944 = leadFormType => WrappedComponent => {
  const ComponentUI = props => {
    const getNewProps = PREPARE_SHOP_3944_PROPS[leadFormType];
    const { make, ...updatedProps } = getNewProps(props);

    return (
      <>
        <WrappedComponent {...updatedProps} />

        {MAKES.includes(make) && (
          <Experiment name="shop-3944-disclaimer" showDefault>
            <Recipe name="ctrl" isDefault />
            <Recipe name="chal1" />
            <Recipe name="chal2" />
            <Recipe name="chal3" />
          </Experiment>
        )}
      </>
    );
  };

  ComponentUI.displayName = 'ComponentShop3944';

  const mapStateToProps = state => ({
    shop3944RecipeName: ExperimentUtil.getForcedOrAssignedRecipeName({
      state,
      campaignName: 'shop-3944-disclaimer',
      defaultVal: 'ctrl',
    }),
  });

  return connect(mapStateToProps)(ComponentUI);
};

export const withShop3944EmbededLeadForm = withShop3944('embeded');
export const withShop3944LeadFormDrawer = withShop3944('basicDrawer');
export const withShop3944TransparentPricing = withShop3944('transparentPricing');
